// @copyright  2006-2024 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: ':id/returns',
        component: () =>
            import(/* webpackChunkName: "investment.investment-returns" */ '@/pages/[organisation]/investment/investment-returns/investment-returns.vue'),
        name: 'investment.investment-returns.search-investment-returns',
        meta: {
            loginRequired: true,
            permission: 'access.finance.investment.investment-returns.view-investment-returns',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import(/* webpackChunkName: "investment.investment-returns" */ '@/pages/[organisation]/investment/investment-returns/investment-return/new.vue'),
                name: 'investment.investment-returns.create-investment-return',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.investment.investment-returns.create-investment-return',
                },
            },
            {
                path: ':returnId/redo',
                component: () =>
                    import(/* webpackChunkName: "investment.investment-returns" */ '@/pages/[organisation]/investment/investment-returns/redo-investment-return.vue'),
                name: 'investment.investment-returns.redo-investment-return',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.investment.investment-returns.redo-investment-return',
                },
            },
        ],
    },
];
